import { FC } from 'react';
import { Typography } from 'antd';
import { ParagraphProps } from 'antd/lib/typography/Paragraph';

const { Paragraph } = Typography;

export const ILSTypographyParagraph: FC<ParagraphProps> = (props) => {
  return <Paragraph {...props} />;
};
